import { ReactNode, useContext } from "react";
import { ConfirmEventContext, ConfirmStateContext } from "./ConfirmContext";

let resolve;

export function useConfirm() {
  const confirmState = useContext(ConfirmStateContext);
  const updateState = useContext(ConfirmEventContext);

  function onConfirm() {
    closeConfirm();
    resolve(true);
  }

  function onCancel() {
    closeConfirm();
    resolve(false);
  }

  async function confirmDialog(
    title: ReactNode,
    description: ReactNode,
    cancelBtnText?: string,
    confirmBtnText?: string,
  ) {
    updateState({
      type: "show",
      title: title,
      description: description,
      cancelBtnText: cancelBtnText,
      confirmBtnText: confirmBtnText,
    });

    return new Promise<boolean>((res) => {
      resolve = res;
    });
  }

  function closeConfirm() {
    updateState({
      type: "hide",
      title: "",
      description: "",
      cancelBtnText: "",
      confirmBtnText: "",
    });
  }

  return { confirmDialog, onConfirm, onCancel, confirmState };
}
